import { ExtendError, getConfiguration, verifyExtend } from "./extend-utils.js";

const cartOfferTag = 'extend-cart-offer';
var cart;
var init = false;

const {
    cartOfferEnabled,
    cartSPEnabled,
    sideCartOfferEnabled,
    cartBalancingEnabled,
    SPEnabled
} = getConfiguration();

var type, selectors;
if (/cart/.test(window.location.pathname) && cartOfferEnabled) {
    selectors = {
        cartContainer: 'cart-items',
        cartRowItem: 'tr.cart-item', // Container element for each item in the cart
        cartRowItemImage: '.cart-item__link', // Product image or image anchor element
        cartRowItemTitle: '.cart-item__name', // Title anchor element for the product
        cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
        warrantyOriginalMeta: 'dl .product-option', // Each warranty metadata item we want to remove.
        offerAnchor: '.cart-item__details', // Container where the offer will be appended
        metadataContainer: '.cart-item__details dl', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: 'quantity-input', // Wrapper for quantity input and buttons
        lineItemRemove: 'cart-remove-button', // Remove button for a line item
        shippingAnchor: '.cart__footer' // Shipping protection offer anchor element
    }
    type = 'main';
} else if (sideCartOfferEnabled) {
    selectors = {
        cartContainer: '.qsc2-drawer',
        cartRowItem: '.qsc2-product-item', // Container element for each item in the cart
        cartRowItemImage: '.qsc2-product-item__image a', // Product image or image anchor element
        cartRowItemTitle: '.qsc2-product-item__product-title a', // Title anchor element for the product
        cartRowItemQuantity: '.qsc2-product-item__quantity-input', // Input element containing the product quantity
        warrantyOriginalMeta: '.qsc2-product-item__option', // Each warranty metadata item we want to remove.
        offerAnchor: '.qsc2-product-item__footer', // Container where the offer will be appended
        metadataContainer: '.qsc2-product-item__variant-option', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: '.qsc2-product-item__quantity', // Wrapper for quantity input and buttons
        lineItemRemove: '', // Remove button for a line item
        shippingAnchor: '' // Shipping protection offer anchor element
    }
    type = 'side';
}

class ExtendCartOffer extends HTMLElement {
    constructor(referenceId, quantity, price, category) {
        super();
        
        this.params = {
            referenceId,
            quantity,
            price,
            category
        }
    }
    
    connectedCallback() {
        this.render();
    }
    
    render() {
        Extend.buttons.renderSimpleOffer(this, {
            referenceId: this.params.referenceId,
            price: this.params.price,
            category: this.params.category,
            onAddToCart: ({ plan, product }) => {
                ExtendShopify.addPlanToCart({
                    plan,
                    product,
                    quantity: this.params.quantity
                }, (err) => {
                    if (err) {
                        throw new ExtendError(err.message);
                    }
                    document.dispatchEvent(new Event('extend.lineItemModified'));
                })
            }
        })
    }
}
if (!customElements.get(cartOfferTag))
    customElements.define(cartOfferTag, ExtendCartOffer);

function createWarrantyOffer(lineItemElement, index) {
    if (!cartOfferEnabled) return;
    
    const cartItem = cart.items[index];
    const referenceId = cartItem.id;
    const quantity = cartItem.quantity;
    const price = cartItem.price;
    const category = cartItem.product_type;
    const warrantyAlreadyInCart = ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) || ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);
    
    let anchor = lineItemElement.querySelector(selectors.offerAnchor);
    
    if (!anchor) {
        throw new ExtendError(`Offer anchor element on line ${index} not found with selector ${selectors.offerAnchor}`);
    }
    
    let extendOffer = lineItemElement.querySelector(cartOfferTag);

    // If the warranty is in the cart, return from this function
    // If the offer exists, remove it before returning
    if (warrantyAlreadyInCart) {
        if (extendOffer) {
            extendOffer.remove();
        }
        return;
    } else {
    // If the warranty is not in the cart, and the offer element is not preset, check if the properties match the offer
    // we are currently trying to create. If not, remove the offer and create a new one
        if (extendOffer) {
            if (extendOffer.params.extendReferenceId !== referenceId ||
                extendOffer.params.extendQuantity !== quantity ||
                extendOffer.params.extendPrice !== price ||
                extendOffer.params.extendCategory !== category
            ) {
                extendOffer.remove();
            }
        }

        let newExtendOffer = new ExtendCartOffer(referenceId, quantity, price, category);
        
        if (type == 'main') {
            anchor.append(newExtendOffer); // append, prepend, after, before
        } else if (type == 'side') {
            anchor.before(newExtendOffer);
        }
    }
}

function styleWarrantyLineItem(lineItemElement, index) {
    lineItemElement.querySelector(selectors.cartRowItemTitle).style.pointerEvents = 'none';
    
    let image = lineItemElement.querySelector(selectors.cartRowItemImage);
    
    if (image) {
        image.style.pointerEvents = 'none';
    } else {
        console.error(`EXTEND: Line item image element on line ${index} not found with selector ${selectors.cartRowItemImage}`)
    }
    
    let warrantyMetadata = lineItemElement.querySelectorAll(selectors.warrantyOriginalMeta);
    
    if (warrantyMetadata?.length) {
        warrantyMetadata.forEach(each => each.remove());
    }
    
    if (selectors.quantityWrapper?.length && lineItemElement.querySelector(selectors.quantityWrapper)) {
        lineItemElement.querySelectorAll(selectors.quantityWrapper).forEach((each) => {
            each.style.opacity = '75%';
            each.style.pointerEvents = 'none';
        });
    }
    
    let contentContainer = lineItemElement.querySelector(selectors.metadataContainer)
    let warrantyProductData;
    let warrantyTermData;
    let cartItem = cart.items[index];
    
    if (cartItem.options_with_values && cartItem.options_with_values[1]) { // Finds the ref id string in the product info string and replaces with an empty string
        let regexReplace = cartItem.options_with_values[0].value.match(/\-\d{5,}/g);
        warrantyProductData = cartItem.options_with_values[0].value.replace(regexReplace, '');
        warrantyTermData = cartItem.options_with_values[1].value;
    } else {
        warrantyProductData = cartItem.properties.Product;
        warrantyTermData = cartItem.properties.Term;
    }
    
    // For category offers, fetch title by filtering through cart for warranted product refId
    if (warrantyProductData === "Covered Product") {
        const coveredProductId = cartItem.properties['_Extend.ProductId'];
        warrantyProductData = cart.items.find((item) => item.id.toString() == coveredProductId).title;
    }
    
    // Appends Product and Term metadata
    if (lineItemElement.querySelector(selectors.metadataContainer)) {
        const metaClassName = type == 'main' ? selectors.warrantyOriginalMeta.split(' ')[1].substring(1) : selectors.warrantyOriginalMeta.substring(1);
        
        let warrantyProductName = document.createElement('div');
        if (type == 'main') {
            warrantyProductName.className = `${metaClassName} extend-warranty-info extend-warranty-info-product`;
            warrantyProductName.innerHTML = `<dt>Product: </dt> <dd>${warrantyProductData}</dd>`;
        } else if (type == 'side') {
            warrantyProductName.className = `${metaClassName} extend-warranty-info extend-warranty-info-product`;
            warrantyProductName.innerHTML = `<span class="qsc2-product-item__option-name"><strong>Product:<strong></span> <span class="qsc2-product-item__option-value">${warrantyProductData}</span>`;
        }

        let warrantyProductTerm = document.createElement('div')
        
        if (type == 'main') {
            warrantyProductTerm.className = `${metaClassName} extend-warranty-info extend-warranty-info-term`;
            warrantyProductTerm.innerHTML = `<dt>Term: </dt> <dd>${warrantyTermData}</dd>`;
        } else if (type == 'side') {
            warrantyProductTerm.className = `${metaClassName} extend-warranty-info extend-warranty-info-term`;
            warrantyProductTerm.innerHTML = `<span class="qsc2-product-item__option-name"><strong>Term:<strong></span> <span class="qsc2-product-item__option-value">${warrantyTermData}</span>`;
        }
        
        // Only append the metadata if it's not already there
        if (!lineItemElement.querySelector('.extend-warranty-info')) {
            contentContainer.append(warrantyProductName, warrantyProductTerm)
        }
    }
}

function renderOrStyleCart(html) {
    let cartContainer = document.querySelector(selectors.cartContainer);
    
    if (!cartContainer) {
        throw new ExtendError(`Invalid cart container selector: ${selectors.cartContainer}`);
    }
    
    cartContainer.querySelectorAll(selectors.cartRowItem).forEach((lineItemElement, index) => {
        let title = lineItemElement.querySelector(selectors.cartRowItemTitle);
        
        if (!title) {
            throw new ExtendError('Line item title not found');
        }
        
        let lowerCaseTitle = title.innerText.toLowerCase();
        
        if (lowerCaseTitle.includes('extend protection')) {
            styleWarrantyLineItem(lineItemElement, index);
        } else {
            createWarrantyOffer(lineItemElement, index);
        }
    });
    
    if (cartSPEnabled)
        createShippingOffer();
}

function normalizeItems(callback) {
    if (SPEnabled) {
        ExtendShopify.updateExtendLineItems({
            balanceCart: cartBalancingEnabled,
            isSPSupported: cartSPEnabled,
            callback
        });
    } else {
        ExtendShopify.normalizeCart({
            balance: cartBalancingEnabled
        }, callback);
    }
}

function refreshCart() {
    if (type === 'side') {
    } else if (type === 'main') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'extend-cart'
        });
        // window.location.reload();
    } else {
        window.location.reload();
    }
}

function verifyCartOffers() {
    verifyExtend();
    
    let error = '';
    if (!selectors) error = `Cart selectors are empty\n`;
    
    if (!type) error += `Cart type not defined\n`;
    
    if (error.length > 0) {
        throw new ExtendError(`Cannot initialize cart offers due to following errors:\n${error}`);
    }
}

function initEventListeners() {

    // Listen for any cart-related network requests
    const cartObserver = new PerformanceObserver(list => {
        list.getEntries().forEach(entry => {
            const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType)
            const isCartChangeRequest = /\/cart\//.test(entry.name)
            if (isValidRequestType && isCartChangeRequest) {
                setTimeout(initCartOffer, 250);
            }
        })
    })
    cartObserver.observe({ entryTypes: ['resource'] })

    // Hard refresh after add plan to cart
    document.addEventListener('extend.lineItemModified', () => {
        if (type == 'main') window.location.reload();
    });
    
    init = true;
}

export function initCartOffer() {
    
    verifyCartOffers();
    
    try {
        if (!window.location.pathname.includes('cart') && !sideCartOfferEnabled) {
            throw new ExtendError('Cannot initialize cart offers - not a cart page');
        }
    } catch (err) {
        console.warn(err.message);
        return;
    }
    
    if (!init) initEventListeners();
    
    normalizeItems((err, data) => {
        cart = data?.cart;
        if (err) {
            throw new ExtendError(err.message);
        }
        if (data?.updates) {
            refreshCart();
        } else {
            renderOrStyleCart();
        }
    });
}